import { captureErrorWithContext } from "./sentry";
export async function copyToClipboard(elementToPositionNear, textToCopy) {
    const tempInput = document.createElement("textarea");
    tempInput.value = textToCopy;
    document.body.appendChild(tempInput);
    tempInput.select();
    try {
        document.execCommand("copy");
        showCopyNotification(elementToPositionNear);
    }
    catch (err) {
        captureErrorWithContext(err, {
            extra: {
                note: "Failed when running copyToClipboard",
                payload: JSON.stringify({
                    textToCopy: textToCopy,
                }),
            },
            tags: {
                priority: "medium",
            },
        });
    }
    document.body.removeChild(tempInput);
}
function showCopyNotification(element) {
    // Create bubble to display notification
    const bubble = document.createElement("div");
    bubble.className =
        "copy-bubble rounded-md bg-blue-500 text-sm text-white p-1";
    bubble.textContent = "Copied";
    document.body.appendChild(bubble);
    // Position it near the clicked element
    const rect = element.getBoundingClientRect();
    bubble.style.fontSize = "0.875rem";
    bubble.style.position = "absolute";
    bubble.style.zIndex = "100";
    bubble.style.left = `${rect.left + rect.width / 2}px`;
    bubble.style.top = `${rect.top - 40}px`;
    // Remove after 1 second
    setTimeout(() => {
        bubble.classList.add("opacity-0", "transition-opacity", "duration-500");
        setTimeout(() => bubble.remove(), 500);
    }, 500);
}
